// extracted by mini-css-extract-plugin
export default {"root":"style_root__I9DHf","title":"style_title__BxELz","notice":"style_notice__h9y2C"};